import * as React from 'react';
import { Fragment } from 'react';
import cx from 'classnames';
import { Nav, Navbar, NavItem, OverlayTrigger, Popover } from 'react-bootstrap';

import style from '../style.module.scss';
import logoImage from './assets/Magoosh-logo-purple-400x90.png';
import doubleChecks from './assets/Double-Checks-120x120.png';
import { NavigationLink, ProfileDropdownLink } from '../types';
import NavLink from '../nav_link/template';

export interface NavBarProps {
  navigationLinks: NavigationLink[];
  profileDropdownLinks: ProfileDropdownLink[];
  showTeacherWarning: boolean;
}

export default class NavBar extends React.Component<NavBarProps, {}> {
  render() {
    return (
      <div className={style.navBar}>
        <div className="visible-xs">{this.renderMobile()}</div>
        <div className="visible-sm">{this.renderTablet()}</div>

        <div className="hidden-xs hidden-sm u-margin-T-m">{this.renderDesktop()}</div>
      </div>
    );
  }

  renderDesktop() {
    return (
      <Fragment>
        {this.renderTeacherWarning()}
        <div className={cx(style.navbarFlexWrapper, 'container u-padding-V-xs')}>
          <div className={cx('u-margin-R-m')}>
            <a href="/">
              <img alt="Magoosh" className={style.logo} src={logoImage} />
            </a>
          </div>

          {this.renderNavLinks()}

          <div className={style.profileDropdown}>
            <OverlayTrigger
              overlay={this.renderProfilePopover()}
              placement="bottom"
              rootClose
              trigger="click">
              <div>
                <span className={cx(style.profileDropdownIcon, 'border-radius-all')}>
                  <span className="fa fa-user" />
                </span>
                <span className={cx(style.profileCaret, 'fa fa-caret-down')} />
              </div>
            </OverlayTrigger>
          </div>
        </div>
      </Fragment>
    );
  }

  renderTablet() {
    return (
      <div>
        {this.renderTeacherWarning()}
        <div className={cx(style.navbarFlexWrapper, style.miniContainer, 'u-padding-V-xs')}>
          <a href="/">
            <img alt="Magoosh" className={style.miniLogo} src={doubleChecks} />
          </a>
          {this.renderNavLinks()}
          <div className={style.profileDropdown}>
            <OverlayTrigger
              overlay={this.renderProfilePopover()}
              placement="bottom"
              rootClose
              trigger="click">
              <div>
                <span className={cx(style.profileDropdownIcon, 'border-radius-all')}>
                  <span className="fa fa-user" />
                </span>
                <span className={cx(style.profileCaret, 'fa fa-caret-down')} />
              </div>
            </OverlayTrigger>
          </div>
        </div>
      </div>
    );
  }

  renderMobile() {
    return (
      <div>
        {this.renderTeacherWarning()}
        <Navbar className={style.mobileMenu} fixedTop inverse>
          <Navbar.Header className="text-center">
            <Navbar.Toggle>
              <div className={cx(style.mobileMenuTrigger, 'text-center')}>
                <img alt="Magoosh" className={style.logo} src={logoImage} />
                <span className="fa fa-chevron-down u-margin-L-xxs" />
              </div>
            </Navbar.Toggle>
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav>
              {this.props.profileDropdownLinks.map((profileLink, idx) => (
                <NavItem eventKey={idx} href={profileLink.url} key={idx}>
                  {profileLink.name}
                </NavItem>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <div className={style.navbarFlexWrapper}>{this.renderNavLinks()}</div>
      </div>
    );
  }

  renderNavLinks() {
    return (
      <div className={cx(style.navLinks)}>
        {this.props.navigationLinks.map((navLink, index) => (
          <NavLink key={index} name={navLink.name} url={navLink.url} selected={navLink.selected} />
        ))}
      </div>
    );
  }

  renderProfilePopover() {
    return (
      <Popover id="profile-popover">
        <div className={style.profileLinkWrapper}>
          {this.props.profileDropdownLinks.map((profileLink, idx) => (
            <div key={idx}>
              <a className={style.profileLink} href={profileLink.url} target={profileLink.target}>
                {profileLink.name}
              </a>
            </div>
          ))}
        </div>
      </Popover>
    );
  }

  renderTeacherWarning() {
    if (this.props.showTeacherWarning) {
      return (
        <div className={style.studentViewWarning}>
          You are viewing the Student Dashboard.{' '}
          <a href="/">Click here to exit back to your instructor account</a>.
        </div>
      );
    }

    return null;
  }
}
